<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,11,0,11C0,11.55,0.45,12,1,12C1,12,5.75,12,5.75,12C5.75,12,5.25,14,5.25,14C5.25,14,4,14,4,14C3.45,14,3,14.45,3,15C3,15.55,3.45,16,4,16C4,16,12,16,12,16C12.55,16,13,15.55,13,15C13,14.45,12.55,14,12,14C12,14,10.75,14,10.75,14C10.75,14,10.25,12,10.25,12C10.25,12,15,12,15,12C15.55,12,16,11.55,16,11C16,11,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM14,10C14,10,2,10,2,10C2,10,2,2,2,2C2,2,14,2,14,2C14,2,14,10,14,10C14,10,14,10,14,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Desktop',
} as DefineComponent
</script>
